import React, { useEffect, useState } from 'react';
import {
    Box, Button, Stack, TextField, Typography
} from '@mui/material';
import axios from 'axios';

const BuildingDetailsCeilingsAddCeiling = ({ buildingId, ceiling, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        area: '',
        u_value: '',
        u_value_uninsulated: ''
    });

    useEffect(() => {
        if (ceiling) {
            setFormData({
                area: ceiling.area,
                u_value: ceiling.u_value,
                u_value_uninsulated: ceiling.u_value_uninsulated
            });
        }
    }, [ceiling]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            area: Number(formData.area),
            u_value: Number(formData.u_value),
            u_value_uninsulated: Number(formData.u_value_uninsulated),
            building: Number(buildingId)
        };

        const method = ceiling ? axios.put : axios.post;
        const url = ceiling
            ? `/buildings/${buildingId}/ceiling/${ceiling.id}/`
            : `/buildings/${buildingId}/ceiling/`;

        console.log(payload)

        method(url, payload)
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => {
                onError();
            });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>{ceiling ? 'Edit Ceiling' : 'Add Ceiling'}</Typography>

            <Stack spacing={2}>
                <TextField
                    label="Area"
                    name="area"
                    type="number"
                    inputProps={{ min: 1, step: 0.1 }}
                    fullWidth
                    required
                    value={formData.area}
                    onChange={handleChange}
                />
                <TextField
                    label="U-Value"
                    name="u_value"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    fullWidth
                    required
                    value={formData.u_value}
                    onChange={handleChange}
                />
                <TextField
                    label="U-Value Uninsulated"
                    name="u_value_uninsulated"
                    type="number"
                    inputProps={{ min: 1, step: 0.1 }}
                    fullWidth
                    required
                    value={formData.u_value_uninsulated}
                    onChange={handleChange}
                />

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="contained" type="submit">{ceiling ? 'Save' : 'Add'}</Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsCeilingsAddCeiling;
